import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import Main_Winter from '../../component/Winter/Main_Winter';
import Save_Date_Fall from '../../component/Fall/Save_Date_Fall';
import axios from 'axios';
import Info_Fall from '../../component/Fall/Info_Fall';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import CallInfo from '../../component/CallInfo';
import ParentInfo from '../../component/Info/ParentInfo';
import Information from '../../component/Information';

const ParkNaRim = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "최영광♥박나림 결혼합니다.";
    const openDesc = "7월 12일 오후 1시";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/231/thumb.jpg";

    const placeTelNum = "041-671-7000";

    const lng =126.33706883699524;
    const lat = 36.48837654674912;

    const forCar = "네비게이션 “충남 태안군 안면읍 꽃지해안로 204“ 입력";
    const forParking = "아일랜드 리솜 앞 야외주차장 이용";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    const conceptStyle = {
        concept: "WINTER",
        titleColor: "#000000",
        pointColor: "#000000",
        btnBgColor: "#000000",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F4F4F4",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Milchella"
    }


    const parents = [
        {groom : "❁최종국 · 김복희의 차남"},
        {bride : "박민규 · 안혜자의 장녀"}
    ]

    const parentInfo = {
        groom: {
            dad: { name: "최종국", isDeceased: true },
            mom: { name: "김복희", isDeceased: false },
            role: "차남",
        },
        bride: {
            dad: { name: "박민규", isDeceased: false },
            mom: { name: "안혜자", isDeceased: false },
            role: "장녀",
        }
    };

    const title = "우리 결혼 합니다."

    const msg1 = "한여름의 푸르른 계절 속에서\n우리는 서로의 그늘이 되고, 햇살이 되어\n이제 하나의 길을 같이 걸어가려 합니다.\n소중한 걸음을 내어 기쁜 날을 함께해 주세요."


    const groomAccountList = [
        {
            role: "신랑",
            name: "최영광",
            bank: "농협",
            accountNumber : "352-0622-5805-93",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej9Hai0NO"
        }
        // ,{
        //     role: "신랑 부",
        //     name: "정창호",
        //     bank: "농협은행",
        //     accountNumber : "356-1541-7272-93",
        //     isKakao : false
        // }
        ,{
            role: "신랑 모",
            name: "김복희",
            bank: "수협",
            accountNumber : "0-01030772593",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "박나림",
            bank: "농협",
            accountNumber : "356-0395-2194-33",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej9NA6yzO"
        }
        ,{
            role: "신부 부",
            name: "박민규",
            bank: "농협",
            accountNumber : "477127-52-061580",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "안혜자",
            bank: "농협",
            accountNumber : "477127-52-145043",
            isKakao : false
        }
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "정우진",
            call: "010-5467-5127"
        }
        ,
        {
            role: "신랑 부",
            name: "정창호",
            call: "010-3867-5127"
        },
        {
            role: "신랑 모",
            name: "김복경",
            call: "010-2425-3349"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "안현주",
            call: "010-2490-9377"
        }
        ,{
            role: "신부 부",
            name: "안인성",
            call: "010-2324-9377"
        }
        ,{
            role: "신부 모",
            name: "김미정",
            call: "010-7935-9377"
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "지하철 앞",
            brideAnswer: "당연하지!"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "긴장 돼",
            brideAnswer: "두근두근"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "널 사랑해",
            brideAnswer: "사랑해❤️"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "한눈 안 팜",
            brideAnswer: "절대 지켜"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "행복하자",
            brideAnswer: "고마워"
        }
    ]

    const informationList =[
        {
            title : "결혼식 뷔페 시간",
            content : "오전 12시 ~ 오후 3시"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#000000"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Winter width={"300px"} weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstNameEn(weddingData.brideNameEn)} groomNameEn={getFirstNameEn(weddingData.groomNameEn)} />
                    <Save_Date_Fall weddingData={weddingData} color={conceptStyle.titleColor} />
                    <Info_Fall parents={parents} conceptStyle={conceptStyle} weddingData={weddingData} />
                    <Letter title={title} msg1={msg1} conceptStyle={conceptStyle} />
                    {/* <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper>  */}
                    <Dday_Spring isAttendFromClose={true} groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    {/* <MotionWrapper initialY={70}>
                        <Message_Spring  weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper> */}
                    {/* <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    </MotionWrapper> */}
                    <Information divHeight={"150px"} conceptStyle={conceptStyle} informationList={informationList} />
                    <MotionWrapper initialY={50}>
                        <Location_Spring  weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                        <Location_Desc forCar={forCar} forParking={forParking} conceptStyle={conceptStyle}/>
                        <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                        <Footer />
                </>
            )}
        </div>
    );
    
};

export default ParkNaRim;